// extracted by mini-css-extract-plugin
export default {"title":"profile_title__efgzU"};